
export const LOGIN = "/login";
export const JWT_VERIFY = "/auth/verifyToken";
export const RESETPASSWORD = (profile) => {
  return `/${profile.companyKey}/${profile.userName}/resetpassword`;
};
export const CHANGEPASSWORD = (profile) => {
  return `/user/${profile.userName}/changepassword`;
};
export const ExchangeRefereshToken = ({ token, companyKey }) =>
  `/auth/exchangeRefreshToken?refreshToken=${token}&companyKey=${companyKey}`;

export const ExportLead = (filename, displayName = "") =>
  `/export?FileName=${filename}${
    displayName ? `&DownloadFileName=${displayName}` : ""
  }&api-version=2.0`;
export const DownloadAttachment = `/downloadattachment`;

export const Profile = {
  get: "/Profiles",
  updateCache: ({ companyKey, profileId }) =>
    `cache/company-${companyKey}/profile-${profileId}`,
};
export const CompanyAPI = {
  get: "/company",
  put: "/company",
  getAll: "/companies",
  getAssignedCompanies: "/companies/assigned",
  export: "companies/export",
};

export const ChatAPI = {
  get: "/chats",
  put: "/company",
  getAll: "/chats",
  getGroups: "/groups/assigned",
  messagingDashboardStatus: (status) => `users/active/${status}`,
  endChat: (chatId) => `chatrooms/${chatId}/close`,
  rejectChat: (chatId) => `chats/${chatId}/text/reject`,
  getChatRoomData: (chatId) => `chatrooms/${chatId}`,
  getSuggestions: (companyId, threeLetterISOLanguageName) =>
    `chatroom/suggestions?companyId=${companyId}&threeLetterISOLanguageName=${threeLetterISOLanguageName}`,
  getUnsentLeads: `chatrooms/?filter=myleads`,
  getChatsHistory: `chatrooms/`,
  updateUnsentLead: ({ chatId, isLead }) =>
    `chatrooms/${chatId}/flaglead?isLead=${isLead}`,
  export: "chats",
  setMessagesAsRead: (chatId) => `/updatechatmessagesasread/${chatId}`,
  setMessageLeadAsRead: (leadId) => `/markmessageleadasread/${leadId}`,
};

export const StatementAPI = {
  getFolders: (companyId, threeLetterISOLanguageName) =>
    `/scripts/multiLanguage/?companyId=${companyId}&threeLetterISOLanguageName=${threeLetterISOLanguageName}`,
  addFolder: "/messaging/folder/add",
  addStatement: "/messaging/suggestions/add",
  removeStatement: "/messaging/suggestions/delete",
};

export const MDSignUpAPI = "messaging/signuprequest";

export const ChatTranferAPI = {
  chatTransferUpdate: (data) =>
    `chatTransfer/${data.chatId}/response/?userId=${data.userId}&response=${data.response}&message=${data.message}`,
};

export const UserAPI = {
  get: "/user",
  put: "/user",
  getAll: "/users",
  getAgents: "/users/agentlist",
  getUserHasMultipleCompanies: "users/multiplecompany",
  uploadImage: "api/apexchatmain",
};

export const LeadAPI = {
  get: "/leads",
  put: "/leads",
  getAll: "/leads",
  post: "/leads",
  export: "/leads",
  uploadAttachment: "/uploadleadattachment?api-version=2",
  getLeadCategories: (companyId) => `company/${companyId}/leadcategories`,
  getRegions: (companyId) => `company/${companyId}/regions`,
  forwardlead: ({ leadId, emails }) =>
    `forwardlead/?leadId=${leadId}&to=${emails}`,
  changeRequestLeadType: ({ leadId, leadType }) =>
    `leads/change/${leadId}/${leadType}/?action=request`,
};

export const CallConnectAPI = {
  post: (data) =>
    `/calls/?to=${data.to}&from=${data.from}&chatId=${data.chatId}`,
};

export const signupAPI = {
  signUpWithEmail: "api/auth/signup/email",
  sendOTPPHone: "api/auth/phone/send-otp",
  verifyOTPPhone: "api/auth/phone/verify-otp",
  resendVerifyEmail: "api/auth/resend-verification",
  getBusinessCategories: "api/signup-business-categories",
  signupwithGoogle: "api/auth/signup/google",
  signupwithGoogleCallback: (code, state) => `api/auth/signup/google/callback?code=${code}&state=${state}`,
  updateSignupUser: (userId) => `api/auth/signup/${userId}`,
};

export const signinApi = {
  signIn: "api/auth/signin",
  callback: (code) => `api/auth/callback?code=${code}`,
};

export const AnalyticAPI = {
  getActivationStats: "/activationstats",
  getLeadgeneratorStats: "/leadgeneratorstats",
  getTopBottomBillersStats: "/leadgeneratorstats",
  getQuickStats: "/quick-stats",
  getFilters: "/getFilters",
  getTopRevenueStats: "/leadgeneratorstats",
  getTopInactiveBillerStats: "/leadgeneratorstats",
  getBudgetPacingStats: "/leadgeneratorstats",
  getAgentImagesCTRStats: "/leadgeneratorstats",
  getAccountsStats: "/leadgeneratorstats",
  getChartsAndGraphs: "/chartsNgraphs",
};

export const general = {
  getMobileSuggestions: "/general/mobile/suggestions",
  getBusinessCategories: "general/businesscategories",
  getBusinessSubCategories: "general/businessSubCategory",
  getServerInfo: "general/AppInfo",
};

export const ReportAPI = {
  get: "/report",
  put: "/report",
  getAll: "/report",
  getList: "/report/reporttypelist",
  post: "/userreports/",
  updateQueuedReport: "/report/updatequeuedreports",
};
export const HostAPI = {
  getOwnedHosts: "/hosts/ownedhosts",
  getHost: (id) => `host/${id}`,
  getMeta: (data) => {
    return `/host/meta?meta.hostDomain=${data?.hostDomain}&meta.hostKey=${data?.hostKey}`;
  },
};
export const ProvisionAPI = {
  get: (id) => `/provision/${id}`,
  getAll: "/provision",
  create: "/provision",
  update: "/provision",
  attachements: "/provision/attachment",
  export: "provisioningrequests/",
  getFeaturesByHostId: (hostId) => `/provision/offered-host-features/${hostId}`,
  getFeaturesByProvisioningId: (provisioningId) =>
    `/provision/offered-provision-features/${provisioningId}`,
};

export const MyReportAPI = {
  getAll: "/report",
  export: "userreports",
};

export const QueuedReportAPI = {
  getAll: "/report/queued",
  downloadQueuedReport: (id, format) =>
    `queueduserreports/${id}?format=${format}`,
  export: "queueduserreports",
};

export const WidgetEditor = {
  sendEmail: `/settings/widgetcode/email`,
  getProfile: (profileId) => `/profiles/${profileId}`,
  getWidget: (path) => `themes/skinnable/${path}`,
};

export const Import = {
  upload: `upload`,
  byId: (recordId) => `lead-imports/${recordId}`,
  aiAnalyze: (recordId) => `lead-imports/${recordId}/ai/analyze`,
  aiSaveMapping: (recordId) => `lead-imports/${recordId}/ai/save-mapping`,
  aiSaveDuplicateSettings: (recordId) =>
    `lead-imports/${recordId}/ai/save-duplicate-settings`,
  aiValidateAndPrepare: (recordId) =>
    `lead-imports/${recordId}/ai/validate-and-prepare`,
  aiExecute: (recordId) => `lead-imports/${recordId}/ai/execute`,
  aiSkippedRows: (recordId) => `lead-imports/${recordId}/ai/skipped-rows`,
  aiStatus: (recordId) => `lead-imports/${recordId}/ai/status`,
};

export const uploadAttachment = "/upload-attachment?api-version=2.0";
export const uploadPublicAppointmentAttachment =
  "/themes/default/logo?api-version=2.0";
export const uploadEmailTemplateAsset =
  "/upload/email-template/asset?api-version=2.0";
export const downloadEmailAttachment = `/download/email/attachment`;
export const previewEmailAttachment = `/preview/email/attachment`;
